import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    checkUrl: String,
    href: String,
    method: { type: String, default: "put" },
    cancelLabel: { type: String, default: "Cancel" },
    confirmLabel: { type: String, default: "Confirm" }
  }

  async open(event) {
    event.preventDefault()
    event.stopImmediatePropagation()

    if (!this.hasCheckUrlValue) {
      this.proceed()
      return
    }

    const response = await fetch(this.checkUrlValue, {
      headers: { "Accept": "application/json" }
    })
    const { warning } = await response.json()

    if (!warning) {
      this.proceed()
      return
    }

    this.showDialog(warning)
  }

  showDialog(message) {
    const dialog = document.createElement("dialog")
    dialog.classList.add(
      "rounded-xl", "p-6", "max-w-md", "shadow-lg",
      "backdrop:bg-black/50"
    )
    dialog.innerHTML = `
      <p class="mb-6 text-gray-800">${message}</p>
      <div class="flex justify-end gap-3">
        <button data-action="cancel" class="px-4 py-2 rounded-full border border-gray text-gray-600 hover:bg-gray-50">
          ${this.cancelLabelValue}
        </button>
        <button data-action="confirm" class="px-4 py-2 rounded-full border border-blue text-blue hover:bg-blue-400 hover:text-white">
          ${this.confirmLabelValue}
        </button>
      </div>
    `

    dialog.querySelector("[data-action=cancel]").addEventListener("click", () => {
      dialog.close()
      dialog.remove()
    })

    dialog.querySelector("[data-action=confirm]").addEventListener("click", () => {
      dialog.close()
      dialog.remove()
      this.proceed()
    })

    document.body.appendChild(dialog)
    dialog.showModal()
  }

  proceed() {
    const form = document.createElement("form")
    form.method = "POST"
    form.action = this.hrefValue
    form.innerHTML = `<input type="hidden" name="_method" value="${this.methodValue}">`
    document.body.appendChild(form)
    form.requestSubmit()
  }
}
